let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3n6Ca")).then(() => parcelRequire('2R4re'));